import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var QuickReplyIcon = function QuickReplyIcon(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("g", {
      children: /*#__PURE__*/_jsx("rect", {
        fill: "none",
        height: "24",
        width: "24"
      })
    }), /*#__PURE__*/_jsx("g", {
      children: /*#__PURE__*/_jsxs("g", {
        children: [/*#__PURE__*/_jsx("g", {
          children: /*#__PURE__*/_jsx("path", {
            d: "M4,17.17V4h16v6h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2.01,2.9,2.01,4L2,22l4-4h9v-2H5.17L4,17.17z"
          })
        }), /*#__PURE__*/_jsx("g", {
          children: /*#__PURE__*/_jsx("polygon", {
            points: "22.5,16 20.3,16 22,12 17,12 17,18 19,18 19,23"
          })
        })]
      })
    })]
  }));
};
export default QuickReplyIcon;